import "../assets/styles/sidebar.scss";
import React, { useEffect, useRef, useState } from "react";
import { Input, Tooltip } from "antd";
import DeleteIcon from "../assets/images/icons/delete_icon.svg";
import { Modal } from "antd";
import { v4 as uuidv4 } from "uuid";
import { Button } from "antd";
import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getUserChatHistory, getChatHistoryById, deleteChatHistoryById, } from "../apis/ChatAIAPI";
import { setCurrentChatHistory } from "../reducers/openChatSlice";
import Scrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import { toggleTour } from "../reducers/tourSlice";
import { togglePrompt } from "../reducers/promptSlice";
import { Auth } from "../libs/utilities/helpers/Auth";
import { getAppMenu } from "../components/CustomHeader"; // Assuming this is where your menu function lives

const treeData = [
  {
    title: "All",
    value: "all",
    key: "0",
    children: [
      {
        title: "FY 2024-25",
        value: "FY 2024-25",
        key: "0-0",
      },
      {
        title: "FY 2023-24",
        value: "FY 2023-24",
        key: "0-1",
      },
    ],
  },
];

const Sidebar = ({ collapsed, setCollapsed }) => {
  const chatLIstRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const refreshSidebar = useSelector((state) => state.openChat);
  const [conversationHistory, setConversationHistory] = useState([]);
  const [historyChat, setHistoryChat] = useState([]);
  const [open, setOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [showChat, setShowChat] = useState(false);
  const [deleteConversationId, setDeleteConversationId] = useState();
  const comp = useRef();
  const user = Auth.getUser();
  const accessibility = user.accessibility.filter(item => item.status);
  const activeServices = accessibility.map(service => service.service);
  const showSidebarPrompt = useSelector((state) => state.prompt).promptSidebarShow;
  const [checkedKeys, setCheckedKeys] = useState(["0"]);
  const [complaint, setComplaint] = useState(true);
  const [er, setEr] = useState(true);
  const [accessibleMenu, setAccessibleMenu] = useState([]);
  const [tooltipStates, setTooltipStates] = useState({});
  const [isMobileView, setIsMobileView] = useState(false);
  const promptSelected = useSelector((state) => state.prompt).show;
  const [searchTerm, setSearchTerm] = useState("");
  const showError = useSelector(state => state.componentError).show;

  useEffect(() => {
    const psContainer = comp.current;

    if (psContainer.scrollHeight > psContainer.clientHeight) {
      // Only initialize PerfectScrollbar if there's overflow
      const ps = new Scrollbar(psContainer);
      return () => {
        ps.destroy();
      };
    }

    // Otherwise, no need for PerfectScrollbar
  }, [conversationHistory]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 450);
    };
    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  useEffect(() => {
    const psContainer = comp.current;
    if (psContainer.scrollHeight > psContainer.clientHeight) {
      psContainer.classList.add("has-scroll");
    } else {
      psContainer.classList.remove("has-scroll");
    }
  }, [conversationHistory]);

  const location = useLocation();

  useEffect(() => {
    if (
      activeServices.includes("chat-ai") &&
      location.pathname === "/chat-ai"
    ) {
      dispatch(getUserChatHistory())
        .then((userChatResponse) => {
          setConversationHistory(userChatResponse.payload.data);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [refreshSidebar.responseReceived]);
  const createNewChat = () => {
    dispatch(togglePrompt({ show: false }));

    let newChatId = uuidv4();
    sessionStorage.setItem("conversation_id", newChatId);
    sessionStorage.setItem("currentChatId", newChatId);

    dispatch(setCurrentChatHistory([]));
    dispatch(getUserChatHistory())
      .then((userChatResponse) => {
        setConversationHistory(userChatResponse.payload.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    setShowChat(false);
    dispatch(togglePrompt({ show: false }));
    if (
      activeServices.includes("chat-ai") &&
      location.pathname === "/chat-ai"
    ) {
      dispatch(getChatHistoryById())
        .then((response) => {
          if (response ?.payload ?.data[0] ?.conversation != undefined)
            setHistoryChat(response ?.payload ?.data[0] ?.conversation);
          else {
            setHistoryChat([]);
          }
        })
        .catch((error) => {
          console.error(error);
        });
      dispatch(getUserChatHistory())
        .then((userChatResponse) => {
          setConversationHistory(userChatResponse.payload.data);
        })
        .catch((error) => {
          console.error(error);
        });
      // }
    }
  }, [location.pathname]);

  // const accessibleServices = getAppMenu(accessibility).filter(item => accessibility.some(menu => menu.service === item.route));
  // const filteredServices = accessibleServices.filter(service =>
  //   service.title.toLowerCase()
  // );
  // useEffect(() => {
  //   let accessibility = user.accessibility.filter(item => item.status);
  //   if (accessibility) {
  //     let menus = getAppMenu(accessibility).filter(item => accessibility.some(menu => menu.service === item.route));
  //     menus.sort((a, b) => {
  //       const priorityA = accessibility.find(item => item.service === a.route);
  //       const priorityB = accessibility.find(item => item.service === b.route);
  //       if (priorityA && priorityB) {
  //         return priorityA.index - priorityB.index;
  //       } else if (priorityA) {
  //         return -1;
  //       } else if (priorityB) {
  //         return 1;
  //       }
  //       return 0;
  //     });
  //     setAccessibleMenu(menus);
  //   }
  // }, [])

  useEffect(() => {
    let accessibility = user ?.accessibility.filter((item) => item.status);
    if (accessibility) {
      let menus = getAppMenu(accessibility).filter((item) =>
        accessibility.some((menu) => menu.service === item.route)
      );
      menus.sort((a, b) => {
        const priorityA = accessibility.find((item) => item.service === a.route);
        const priorityB = accessibility.find((item) => item.service === b.route);
        if (priorityA && priorityB) {
          return priorityA.index - priorityB.index;
        } else if (priorityA) {
          return -1;
        } else if (priorityB) {
          return 1;
        }
        return 0;
      });
      setAccessibleMenu(menus);
    }
  }, []);

  const getChatByID = (data) => {
    dispatch(togglePrompt({ show: false }));
    sessionStorage.setItem("currentChatId", data);
    // setCurrentChatId(data)
    sessionStorage.setItem("conversation_id", data);
    dispatch(getChatHistoryById())
      .then((response) => {
        dispatch(
          setCurrentChatHistory(response ?.payload.data[0] ?.conversation)
        );
        setHistoryChat(response ?.payload.data[0] ?.conversation);
      })
      .catch((error) => { });

    dispatch(getUserChatHistory())
      .then((userChatResponse) => {
        setConversationHistory(userChatResponse.payload.data);
      })
      .catch((error) => {
        console.error(error);
      });
    // console.log(response.payload)
  };

  const handelshowChat = () => {
    setShowChat((prev) => !prev);
  };

  const handelChatDelete = async () => {
    const payload = { conversation_id: deleteConversationId };
    dispatch(deleteChatHistoryById(payload))
      .then((res) => {
        let converstiondata = [...conversationHistory];
        converstiondata = converstiondata.filter(
          (item) => item.conversation_id !== deleteConversationId
        );
        setConversationHistory(converstiondata);
      })
      .catch((err) => {
        // console.error(err);
      });
    setDeleteOpen(false);
  };

  const ChatList = () => {
    const compchat = useRef();

    useEffect(() => {
      let ps = new Scrollbar(compchat.current);
      return () => {
        if (ps) {
          ps.destroy();
          ps = null;
        }
      };
    }, []);

    const handelDeleteClick = async (e, id) => {
      e.stopPropagation();
      setDeleteConversationId(id);
      setDeleteOpen(true);
    };

    return (
      <div className="list-chat" ref={compchat}>
        {/* <div  > */}

        {conversationHistory ?.map((data, index) => (
          <>
            <div
              key={data.conversation_id}
              onClick={() => getChatByID(data.conversation_id)}
              className={
                sessionStorage.getItem("conversation_id") ==
                  data.conversation_id
                  ? "chat-history-tile highlighted"
                  : "chat-history-tile"
              }
            >
              <div className="chat-history-tile-text">
                {sessionStorage.getItem("conversation_id") !=
                  data.conversation_id
                  ? data ?.conversation_title ?.slice(0, 15) + "..."
                    : "Current chat"}
              </div>
              <div
                className={`${
                  sessionStorage.getItem("conversation_id") ==
                    data.conversation_id
                    ? "chat_delete_icon-show"
                    : ""
                  } chat_delete_icon`}
                onClick={(e) => handelDeleteClick(e, data.conversation_id)}
                style={{ height: "14px" }}
              >
                <img src={DeleteIcon} width={14} alt="del" />
              </div>
            </div>
          </>
        ))}
      </div>
    );
  };

  const handleTakeATour = () => {
    dispatch(toggleTour({ show: true }));
  };

  const showPrompt = () => {
    dispatch(togglePrompt({ show: true }));
  };

  // const handleTabChange = (value) => {
  //   dispatch(toggleWindow(value ? "chat" : "graphical"));
  // };

  // Helper function to find titles from keys
  const getTitlesFromKeys = (keys, nodes) => {
    let titles = [];

    const findTitles = (nodes) => {
      nodes.forEach((node) => {
        if (keys.includes(node.key)) {
          titles.push(node.title);
        }
        if (node.children) {
          findTitles(node.children); // Recursively find children
        }
      });
    };

    findTitles(nodes);
    return titles;
  };
  const handelNavigation = (route) => {
    navigate(`/${route}`);
    if (isMobileView) {
      setCollapsed(!collapsed)
    }
  }
  const filteredServices = accessibleMenu.filter((service) =>
    service.title.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const handleTooltipOpen = (idx, visible) => {
    setTooltipStates((prev) => ({
      ...prev,
      [idx]: visible,
    }));
  };
  return (
    <div
      className="sidebar"
      ref={comp}
      style={{ padding: !collapsed ? "10px 5px 10px 5px" : "15px 5px" }}
    >
      <div className="top-sidebar">
        <div className="service-content">
          <div style={{ padding: "0px 5px" }}>
            <Input placeholder="Search services"
              value={searchTerm}
              theme="bubble"
              onChange={(e) => setSearchTerm(e.target.value)}
              className="service-serch-input"
            />
          </div>
          <div className="service-main">
            <div className="service-list">
              {filteredServices.map((service, idx) => {
                const isActive = location.pathname === `/${service.route}`;
                return (
                  <div key={idx}>
                    <Tooltip placement="right" title={service.info} key={idx} open={!!tooltipStates[idx]}
                      onOpenChange={(visible) => handleTooltipOpen(idx, visible)}>
                      <div
                        className={`item-side sub-item chatdiv ${isActive ? "active-service" : ""}`}
                        onClick={() => {
                          handelNavigation(service.route)
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        {service.title}
                      </div>
                    </Tooltip>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div>
          {!collapsed && (
            <div className="sidebar-bottom">
              <div className="footer">©2024, HDFC Life</div>
            </div>
          )}
        </div>
      </div>


      <Modal
        title="Are you sure you want to delete chat?"
        open={deleteOpen}
        onCancel={() => setDeleteOpen(false)}
        footer={[
          <Button key="okay" type="text" onClick={() => setDeleteOpen(false)}>
            Cancel
          </Button>,
          <Button key="okay" type="primary" onClick={handelChatDelete}>
            Okay
          </Button>,
        ]}
      >
        {/* <p>{modalText}</p> */}
      </Modal>
    </div>
  );
};

export default Sidebar;
